// extracted by mini-css-extract-plugin
export var statItem = "_ik-1";
export var statsRow = "_ik-0";